import { withTranslation } from "next-i18next";
import sizeEquivalenceTables from "@utils/sizeEquivalenceTables";
import classNames from "classnames";

const customer = process.env.NEXT_PUBLIC_CUSTOMER;

function SizeEquivalenceTable({ t, sizeType }) {
  return (
    <table
      className="table mt-5 text-center"
      style={{ tableLayout: "fixed", width: "100%" }}
    >
      <thead className="pt-5">
        <tr className="pt-3">
          <th className="border-0 bg-transparent">{t(`product:size_reference_table_title.${sizeType}`)}</th>
          <th className="border-0 bg-transparent">{t("product:size_reference_table_title.size_ref")}</th>
        </tr>
      </thead>
      <tbody>
        {Object.entries(sizeEquivalenceTables[customer][sizeType]).map(([key, value], index) => {
          const bg = index % 2 === 0 ? "bg-lighter-gray" : "bg-white";

          return (
            <tr key={key} className={classNames("border-0", bg)}>
              <td className="border-0 text-center">{key}</td>
              <td className="border-0 text-center">{value}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  )
};

export default withTranslation("product")(SizeEquivalenceTable);